export default function initAddress() {
  // if(process.env.NODE_ENV === 'production'){
    window.basic_prefix_api = '//eq.10jqka.com.cn';
    window.prefix_api = '/gmgNewStocks/api/list';
    window.prefix_detail = '/gmgNewStocks/api/detail';
    window.prefix_header = '/gmgNewStocks/api/header';
    //配售结果页
    window.prefix_center = '/gmgNewStocks/api/center';
    //发行资料接口
    window.prefix_available = '/gmgNewStocks/api/center/subscription/issue_info';
    //进度条、认购倍数
    window.progress_api = '/gmgNewStocks/api/center/subscription/detail';
    //新闻接口
    window.news_api = '//eq.10jqka.com.cn/listv4/hk/';
    //大v观点数据列表接口
    window.view_api = '//t.10jqka.com.cn/contentlib/api/access/get_dist_stock';
    //大v观点点赞接口
    window.likes_api = '//bbsclick.10jqka.com.cn/getlist';
    //用户点赞
    window.likes_api_one = '//bbsclick.10jqka.com.cn/inc';
    //页面地址
    window.page_url = '//eq.10jqka.com.cn/hkNewStock/availabledata.html';
    //回测地址
    window.huice_url = '//eq.10jqka.com.cn/hkNewStock/newStockCenter.html';
    //配售结果页
    window.result_api = '//eq.10jqka.com.cn/hkNewStock/result.html';
    //图片cdn路径
    window.cdn_path = '//s.thsi.cn/cd/mobileweb-eq-front-page-container/hkNewStock/';
    window.gmg_trade_Url = '//eq.10jqka.com.cn/apiPlatform/config/open/api/v2/query/hk_trade:gmg_new_stock:qsid_new_stock_url.json';
    window.gmg_isHideHkUsTrade_url = '//eq.10jqka.com.cn/open/api/config_issue/config/v2/query/Android_gmg_trade:isHideHkUsTrade.json';
  // }else{
    // window.basic_prefix_api = '//testm.10jqka.com.cn';
    // window.prefix_api = '/gmgNewStocks/api/list';
    // window.prefix_detail = '/gmgNewStocks/api/detail';
    // window.prefix_header = '/gmgNewStocks/api/header';
    // //配售结果页
    // window.prefix_center = '/gmgNewStocks/api/center';
    // //发行资料接口
    // window.prefix_available = '/gmgNewStocks/api/center/subscription/issue_info';
    // //新闻接口
    // window.news_api = '//eq.10jqka.com.cn/listv4/hk/';
    // //进度条、认购倍数
    // window.progress_api = '/gmgNewStocks/api/center/subscription/detail';
    // //大v观点数据列表接口
    // window.view_api = '//t.10jqka.com.cn/contentlib/api/access/get_dist_stock';
    // //大v观点点赞接口
    // window.likes_api = '//bbsclick.10jqka.com.cn/getlist';
    // //用户点赞
    // window.likes_api_one = '//bbsclick.10jqka.com.cn/inc';
    // //页面地址
    // window.page_url = '//testm.10jqka.com.cn/eq/hkNewStock/availabledata.html';
    // //回测地址
    // window.huice_url = '//testm.10jqka.com.cn/eq/hkNewStock/newStockCenter.html';
    // //配售结果页
    // window.result_api = '//testm.10jqka.com.cn/eq/hkNewStock/result.html';
    // //图片cdn路径
    // window.cdn_path =
    //   '//testm.10jqka.com.cn/cd/mobileweb-eq-front-page-container/hkNewStock/';
    // //qsId->新股申购配置接口
    // window.gmg_trade_Url = '//testm.10jqka.com.cn/apiPlatform/config/open/api/v2/query/gmg_new_stock:qsid_new_stock_url.json';
    // window.gmg_isHideHkUsTrade_url = '//testm.10jqka.com.cn/eq/open/api/config_issue/config/v2/query/Android_gmg_trade:isHideHkUsTrade.json';
  // }
}
